import { useEffect } from 'react';
import { AppProps } from 'next/app';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { useApollo, useStore } from '../services';
import * as environment from '../environment';
import 'tailwindcss/tailwind.css';
import '../styles/main.css';
import { AnimateSharedLayout } from 'framer-motion';
import { usePageView } from '../gtm/effects/page-view.effect';

const application: string =
  process?.env?.APP_ENV || process?.env?.NEXT_PUBLIC_APP_ENV || 'staging';

const gateway =
  environment.envApolloUrls[application as 'prod' | 'uat' | 'staging' | 'local']
    ?.gateway ||
  process?.env?.NEXT_PUBLIC_GATEWAY_URL ||
  'https://service-gateway.staging.eu-west-2.waldocloud.com';

function MyApp({ Component, pageProps }: AppProps): any {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then(
          (registration) => {
            console.log(
              'Service Worker registration passed: ',
              registration.scope
            );
          },
          (err) => {
            console.log('Service Worker registration failed: ', err);
          }
        );
      });
    }
  }, []);

  const store = useStore(pageProps.initialReduxState);
  const apolloClient = useApollo(pageProps.initialApolloState, gateway);

  usePageView();

  return (
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <AnimateSharedLayout>
          <Component {...pageProps} />
        </AnimateSharedLayout>
      </ApolloProvider>
    </Provider>
  );
}

export default MyApp;
